/**
 *
 * @description 自定义指令： v-money 转千分符数字
 * @description 需要在外层包裹父节点
 * @param {app} app vue实例
 */

import { copyText } from '@/utils/copyText';

function install(app) {
    app.directive('copy', {
        mounted: function (el, binding) {
            el.__VCopyValue = binding.value;
            el.__VCopyOnClick = e => {
                e.preventDefault();
                e.stopPropagation();
                copyText(el.__VCopyValue);
            };
            el.addEventListener('click', el.__VCopyOnClick);
        },
        updated: function (el, binding) {
            el.__VCopyValue = binding.value;
        },
        unmounted: function (el, binding) {
            el.removeEventListener('click', el.__onClick);
        }
    });
}

export default {
    install: install
};
